var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductDescriptionItemTwo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.44531 10.1389H15.5564V8.75H4.44531V10.1389Z",
    fill: "#47423D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5564 12.9167H4.44531V11.5278H15.5564V12.9167Z",
    fill: "#47423D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44531 15.6946H15.5564V14.3057H4.44531V15.6946Z",
    fill: "#47423D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6947 1.11084V5.55529H17.2224C18.1429 5.55529 18.8891 6.30148 18.8891 7.22195V17.222C18.8891 18.1424 18.1429 18.8886 17.2224 18.8886H2.77799C1.85752 18.8886 1.11133 18.1424 1.11133 17.222V7.22195C1.11133 6.30148 1.85752 5.55529 2.77799 5.55529H9.30577V1.11084H10.6947ZM17.2224 6.94418H2.77799C2.62458 6.94418 2.50022 7.06854 2.50022 7.22195V17.222C2.50022 17.3753 2.62458 17.4998 2.77799 17.4998H17.2224C17.3759 17.4998 17.5002 17.3753 17.5002 17.222V7.22195C17.5002 7.06854 17.3759 6.94418 17.2224 6.94418Z",
    fill: "#47423D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductDescriptionItemTwo);
export default __webpack_public_path__ + "static/media/product-description-item-two.f77f0b22ac81b61dc693a4c81348ac1d.svg";
export { ForwardRef as ReactComponent };